module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"users":{"profile":{"portfolios":{"action":"Portfolio erstellen","empty_state":"Erstellen Sie eigene Portfolios, die Sie mit anderen Community-Mitgliedern teilen oder privat nutzen können. Bei Updates erhalten Sie Mitteilungen, damit Sie immer auf dem Laufenden sind.","title":"Portfolios"}}}}}}}')
  delete Component.options._Ctor
}
